import styled from 'styled-components'
import ReactSelect from 'react-select'

import { textStyles } from '../../theme'

export const Select = styled(ReactSelect)`
  ${textStyles.locale}
`
